import GridImageWithParagraph from "segments/desktop/core-components/grid-image-with-paragraph/grid-image-with-paragraph";
import { MD, XS } from "constants/sizes";

export const getGridImageWithParagraphProps = (imageSrc, fullParagraphTitle, fullParagraphBody) => {
  const fullParagraph = {
    ...GridImageWithParagraph.defaultProps.fullParagraph,
    title: fullParagraphTitle,
    body: fullParagraphBody
  };

  return {
    ...GridImageWithParagraph.defaultProps,
    src: imageSrc,
    fullParagraph
  };
};

export default {
  gridItems: [
    getGridImageWithParagraphProps(
      "/static/img/card-grid/card-placeholder-image.png",
      "Cross-functional collab blog",
      "Look at your data differently with multiple View options from Calendar to Map."
    ),
    getGridImageWithParagraphProps(
      "/static/img/card-grid/card-placeholder-image.png",
      "Relevant story/video",
      "Automate repetitive tasks and have more time for the work that motivates you."
    ),
    getGridImageWithParagraphProps(
      "/static/img/card-grid/card-placeholder-image.png",
      "Productivity blog or marketing blog",
      "Get a high-level overview at a glance and make smarter decisions, faster."
    )
  ],
  paddingTop: "64px",
  paddingBottom: "64px",
  titleSize: XS,
  textSize: MD
};
